// import moment from 'moment';
// import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import { addToCart } from 'store/features/cartSlice';

const CardScheduleClass = ({ item, pickDate, type }) => {
  const navigation = useNavigate();
  //   const dispatch = useDispatch();

  const goToBuy = (paramsId) => {
    navigation(`/checkout/${paramsId}`);
  };

  //   const handleAdd = (product) => {
  //     dispatch(addToCart(product));
  //   };

  return (
    <div className="flex flex-col gap-4 text-kin-text">
      <div className="flex flex-row items-center gap-2">
        <div className="w-[120px] hidden md:flex flex-col">
          <span className="text-base font-semibold">9:00 AM</span>
          <span className="text-sm font-light">60 Menit</span>
        </div>
        <div className="bg-white flex flex-col md:flex-row md:items-center justify-between font-semibold rounded-xl py-4 px-6 flex-1">
          <div className="flex flex-row gap-1 justify-start items-center mb-3 md:mb-0 md:hidden">
            <span className="text-base font-semibold">9:00 AM</span>
            <span className="text-base font-semibold">|</span>
            <span className="text-base font-light">60 Menit</span>
          </div>
          <div className="flex flex-col mb-3 md:mb-0 md:flex-row justify-between md:items-center flex-1">
            <div className="flex flex-col gap-1 leading-none flex-1">
              <span className="text-sm font-light hidden md:block">ART & CRAFT</span>
              <span className="text-lg font-bold">Puppet Making in the Drizzle Forest</span>
              <span className="text-sm font-light hidden md:block">RIMBA</span>
              <div className="flex flex-row gap-1 justify-start items-center md:hidden mt-1">
                <span className="text-sm font-light "> ART & CRAFT</span>
                <span className="text-sm font-light ">|</span>
                <span className="text-sm font-light ">RIMBA</span>
              </div>
            </div>
            <div className="flex flex-col gap-[6px] justify-start items-start leading-none flex-1 mt-4">
              <div className="flex flex-row items-center gap-2">
                <div className="w-4 h-4 relative">
                  <img
                    alt="icon-star"
                    src="/kin/assest/image/icon-star.svg"
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                </div>
                <span className="text-sm font-regular">Toddler (1.5-3 yo)</span>
              </div>
              <div className="flex flex-row items-center gap-2">
                <div className="w-4 h-4 relative">
                  <img
                    alt="icon-star"
                    src="/kin/assest/image/icon-user.svg"
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                </div>
                <span className="text-sm font-regular">Ms. Rika</span>
              </div>
              <div className="flex flex-row items-center gap-2">
                <div className="w-4 h-4 relative">
                  <img
                    alt="icon-clock"
                    src="/kin/assest/image/icon-calender.svg"
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                </div>
                <span className="text-sm font-regular">60 mins</span>
              </div>
            </div>
          </div>
          {/* <button
            onClick={() => goToBuy('iddss')}
            className="bg-primary-main text-white rounded-[100px] py-2 px-3 flex justify-center items-center">
            <span className="text-xs font-semibold block">BOOK NOW</span>
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default CardScheduleClass;
